<template>
  <section class="identify-customer-container">
    <div class="identify-content">
      <div class="logo-container">
        <div class="logo-icon">
          <img
            :src="require('@/assets/images/logo/echope_small.png')"
            width="150px"
            style="border-radius: 20px"
          >
        </div>
      </div>

      <div class="text-container">
        <img
          class="ticket-icon ticket-icon-top"
          :src="require('@/assets/images/icons/voucher_ticket.png')"
          alt=""
        >
        <h1 class="promo-title">
          DIGITE<br>
          SEU CPF E<br>
          <span class="highlight">CONCORRA<br>A CUPONS</span>
        </h1>
        <img
          class="ticket-icon ticket-icon-bottom"
          :src="require('@/assets/images/icons/voucher_ticket.png')"
          alt=""
        >
      </div>

      <div class="input-container">
        <div class="cpf-input">
          <input
            id="clientDocument"
            v-model="cpf"
            v-mask="'###.###.###-##'"
            type="text"
            class="cpf-field"
            :class="{ invalid: showInvalidCpfMessage }"
            placeholder="Clique para informar o CPF"
            maxlength="14"
            autocomplete="off"
            @focus="onFocus"
            @blur="onBlur"
            @input="onCpfInput"
            @keyup.enter="onContinue"
          >
          <div v-if="showInvalidCpfMessage" class="invalid-cpf-message">
            {{ $t('CPF inválido') }}
          </div>
        </div>

        <button
          v-if="continueVisible"
          :disabled="!isValidCpf"
          class="continue-btn"
          :class="{ enabled: isValidCpf }"
          @click="onContinue"
        >
          Continuar
        </button>
      </div>
    </div>

    <div class="footer-container">
      <div class="qrcode-container">
        <img
          class="qrcode-image"
          :src="require('@/assets/images/logo/qrcode_ecashback.png')"
          alt="QR Code eCashback"
        >
        <p class="qrcode-text">
          <strong>Caso não tenha uma conta no app,</strong><br>
          escaneie o QR Code e crie sua conta.
        </p>
      </div>

      <button
        class="skip-btn"
        @click="onSkip"
      >
        Não quero participar
      </button>
    </div>
  </section>
</template>

<script>
import {
  app,
  loadingOverlay,
  alerts,
  payboxConfiguration,
  pdvBrowserNotAllowedConfiguration,
} from '@/mixins'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { validateBr } from 'js-brasil'

export default {
  mixins: [app, loadingOverlay, alerts, payboxConfiguration, pdvBrowserNotAllowedConfiguration],

  data() {
    return {
      cpf: '',
      continueVisible: false,
    }
  },

  computed: {
    ...mapGetters('pages/pdv/atm/status', {
      stHasPendingSaleToFinishInAtm: 'hasPendingSaleToFinishInAtm',
    }),

    isValidCpf() {
      // Remove caracteres não numéricos
      const cleanCpf = this.cpf.replace(/\D/g, '')
      return validateBr.cpf(cleanCpf)
    },

    showInvalidCpfMessage() {
      // Mostra mensagem de erro quando o CPF está totalmente preenchido mas é inválido
      return this.cpf.length === 14 && !this.isValidCpf
    },
  },

  watch: {
    // a venda do IndexedDB é restaurada pelo loadPdvData depois do mounted
    async stHasPendingSaleToFinishInAtm(hasPendingSale) {
      if (hasPendingSale) {
        await this.navigateToAtmHome()
      }
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe(async mutation => {
      if (mutation.type.startsWith('pages/pdv/payBox')) {
        await this.$store.dispatch('pages/pdv/payBox/updatePdvSession', {})
      }
      if (mutation.type.startsWith('pages/pdv/atm/status')) {
        await this.$store.dispatch('pages/pdv/atm/status/updateAtmStatus', {})
      }
    })
  },

  async mounted() {
    if (this.stHasPendingSaleToFinishInAtm) {
      await this.navigateToAtmHome()
      return
    }

    await this.stSecureCleanAtmState()
  },

  beforeMount() {
    // Impede o redirecionamento automático do mixin payboxConfiguration
    // pois queremos que o usuário permaneça na tela de identificação
    this.mxRedirectWhenMount = false
  },

  methods: {
    ...mapActions('app/simpleKeyboard', ['showKeyboard', 'hideKeyboard']),
    ...mapActions('pages/pdv/payBox', {
      stSearchAndSetClient: 'searchAndSetClient',
      stCleanClientForm: 'cleanClientForm',
    }),
    ...mapActions('pages/pdv/atm', {
      stSecureCleanAtmState: 'secureCleanAtmState',
    }),

    async navigateToAtmHome() {
      try {
        await this.$router.push({ name: 'pdv-atm' })
      } catch (error) {
        const isRedirectedByGuard = error?.message?.includes('Redirected when going')
        const isNavigationDuplicated = error?.name === 'NavigationDuplicated'

        if (!isRedirectedByGuard && !isNavigationDuplicated) {
          throw error
        }
      }
    },

    // eslint-disable-next-line func-names
    onBlur: _.debounce(async function (event) {
      this.$nextTick(() => {
        const input = this.$el.querySelector('#clientDocument')
        if (!this.cpf) {
          input.placeholder = 'Clique para informar o CPF'
          this.continueVisible = false
        }
      })

      this.$emit('blur', event.target?.value, event)

      // if (this.isOskEnabled) {
      this.hideKeyboard()
      // }
    }, 50),

    // eslint-disable-next-line func-names
    onFocus: _.debounce(async function (event) {
      this.$nextTick(() => {
        const input = this.$el.querySelector('#clientDocument')
        input.placeholder = ''
        this.continueVisible = true
      })

      document.getElementById(event.target?.id).select()

      // if (this.applyFocusIntercept(event)) {
      //   return
      // }

      this.inputShowOsk(event)

      this.$emit('focus', event.target?.value, event)
    }, 50),

    applyFocusIntercept(event) {
      if (!this.$listeners['focus-intercept']) {
        return false
      }

      // eslint-disable-next-line func-names
      this.$emit('focus-intercept', (showOsk = true) => {
        if (showOsk) this.inputShowOsk(event)
      })

      return true
    },

    inputShowOsk(event) {
      // if (!this.isOskEnabled) {
      //   return
      // }

      this.showKeyboard({
        el: event.target,
        layoutType: 'numeric',
        selectAllText: true,
      })
    },

    onDocumentFocus() {
      // Seleciona todo o texto ao focar no campo
      this.$nextTick(() => {
        const input = this.$el.querySelector('#clientDocument')
        input.placeholder = ''
        this.continueVisible = true
      })
    },

    onDocumentBlur() {
      // Seleciona todo o texto ao focar no campo
      this.$nextTick(() => {
        const input = this.$el.querySelector('#clientDocument')
        if (!this.cpf) {
          input.placeholder = 'Clique para informar o CPF'
          this.continueVisible = false
        }
      })
    },

    onCpfInput() {
      // Limita a entrada apenas a números
      this.cpf = this.cpf.replace(/[^\d.-]/g, '')
    },

    async onContinue() {
      console.log('CPF digitado:', this.cpf, ' - Válido:', this.isValidCpf)
      if (!this.isValidCpf) {
        return
      }

      if (this.stHasPendingSaleToFinishInAtm) {
        await this.navigateToAtmHome()
        return
      }

      try {
        this.showLoadingOverlay('Carregando informações do cliente...')

        // Remove formatação do CPF
        const cleanCpf = this.cpf.replace(/\D/g, '')

        // Busca e define o cliente
        await this.stSearchAndSetClient({ document: cleanCpf })

        // Navega para a tela principal do ATM
        await this.navigateToAtmHome()
      } catch (error) {
        // Em caso de erro, ainda permite continuar
        console.warn('Cliente não encontrado, continuando sem identificação:', error)
        await this.navigateToAtmHome()
      } finally {
        this.hideLoadingOverlay()
      }
    },

    async onSkip() {
      // Navega diretamente para a tela principal do ATM sem identificar cliente
      await this.navigateToAtmHome()
    },
  },
}
</script>

<style lang="scss" scoped>
// Layout pensado para o totem em retrato (1080x1920); as medidas acompanham
// o menor entre largura e altura para manter as proporções do layout.
$lime: #c1e01f;

.identify-customer-container {
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  background: #006e2e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-family: 'Baloo2-Regular', 'Arial', sans-serif;
  padding: min(8vw, 4.5vh) 16px min(6vw, 3.5vh);
  overflow: hidden;
}

.identify-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  flex: 1;
  justify-content: center;
  min-height: 0;
}

.logo-container {
  margin-bottom: min(7vw, 4vh);
}

.logo-icon img {
  width: min(15.5vw, 9vh) !important;
  height: auto;
}

.text-container {
  position: relative;
  margin-bottom: min(11vw, 6.3vh);
}

.promo-title {
  font-size: min(11.5vw, 6.5vh);
  line-height: 1.02;
  font-family: 'Baloo2-Bold', 'Arial', sans-serif;
  font-weight: bold;
  color: white;
  margin: 0;

  .highlight {
    color: $lime;
  }
}

.ticket-icon {
  position: absolute;
  pointer-events: none;
}

.ticket-icon-top {
  width: min(16vw, 9vh);
  top: -6%;
  left: -16%;
}

.ticket-icon-bottom {
  width: min(10vw, 5.6vh);
  bottom: 4%;
  right: -20%;
}

.input-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cpf-input {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: min(3vw, 1.6vh);
}

.cpf-field,
.continue-btn,
.skip-btn {
  width: min(70vw, 760px);
  border: none;
  border-radius: 999px;
}

.cpf-field {
  height: min(11.5vw, 6.5vh);
  font-size: min(4vw, 2.3vh);
  padding: 0 20px;
  background-color: white;
  color: #333;
  text-align: center;
  letter-spacing: 2px;
  transition: all 0.3s ease;

  &::placeholder {
    color: #aaa;
    font-size: min(2.8vw, 1.6vh);
    letter-spacing: normal;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }

  &.invalid {
    box-shadow: 0 0 10px rgba(231, 76, 60, 0.5);
  }
}

.invalid-cpf-message {
  color: #e74c3c;
  font-size: 24px;
  margin-top: 8px;
  text-align: center;
  font-weight: bold;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.continue-btn {
  height: min(9vw, 5vh);
  background-color: #8aa65c;
  color: white;
  font-family: 'Baloo2-Bold', 'Arial', sans-serif;
  font-size: min(3.6vw, 2vh);
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.5;

  &:disabled {
    cursor: not-allowed;
  }

  &.enabled {
    opacity: 1;
    background-color: #9bc53d;

    &:active {
      transform: translateY(1px);
    }
  }
}

.footer-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.qrcode-container {
  display: flex;
  align-items: center;
  gap: min(2.5vw, 1.4vh);
  margin-bottom: min(4vw, 2.3vh);
}

.qrcode-image {
  width: min(14vw, 7.8vh);
  height: min(14vw, 7.8vh);
  background-color: white;
  padding: min(0.6vw, 0.35vh);
}

.qrcode-text {
  margin: 0;
  color: white;
  text-align: left;
  font-size: min(2.5vw, 1.4vh);
  line-height: 1.25;

  strong {
    font-family: 'Baloo2-Bold', 'Arial', sans-serif;
  }
}

.skip-btn {
  height: min(10vw, 5.6vh);
  background-color: #047f36;
  color: rgba(255, 255, 255, 0.75);
  font-size: min(4.2vw, 2.4vh);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: white;
  }
}
</style>
